import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUtil } from '../utils/http-util';
import { Paged } from '../models/shared/paged';
import { environment } from 'src/environments/environment';

import {
  GetCatalogResourceInventory,
  GetInventoryMovement,
  GetInventoryKpis,
  GetInventoryConfiguration,
  AddInventoryAdjustment,
  GetInventoryReservationTTL
} from '../models/inventory/inventory';

@Injectable({
  providedIn: 'root'
})
export class InventoryService {

  private http = inject(HttpClient);
  private apiBaseUrl = environment.api.url;

  getResourcesWithInventory(
    resourceName?: string,
    typeFilter?: string,
    options?: { page?: number; pageSize?: number }
  ): Observable<Paged<GetCatalogResourceInventory>> {
    return this.http.get<Paged<GetCatalogResourceInventory>>(
      `${this.apiBaseUrl}/inventory/resources`,
      {
        params: HttpUtil.toHttpParams({
          resourceName,
          typeFilter,
          ...options
        })
      }
    );
  }

  exporttResourcesWithInventoryCsv(
     resourceName?: string,
    typeFilter?: string,
  ) {
    return this.http.get(
      `${this.apiBaseUrl}/inventory/resources/export`,
      {
        params: HttpUtil.toHttpParams({
          resourceName,
          typeFilter
        }),
        responseType: 'text'
      }
    );
  }


  getInventoryKpis(versionId: number): Observable<GetInventoryKpis> {
    return this.http.get<GetInventoryKpis>(
      `${this.apiBaseUrl}/inventory/${versionId}/kpis`
    );
  }

  getInventoryMovements(
    versionId: number,
    options?: { page?: number; pageSize?: number }
  ): Observable<Paged<GetInventoryMovement>> {
    return this.http.get<Paged<GetInventoryMovement>>(
      `${this.apiBaseUrl}/inventory/${versionId}/movements`,
      {
        params: HttpUtil.toHttpParams(options ?? {})
      }
    );
  }

  getInventoryConfiguration(versionId: number): Observable<GetInventoryConfiguration> {
    return this.http.get<GetInventoryConfiguration>(
      `${this.apiBaseUrl}/inventory/${versionId}/configuration`
    );
  }

  addInventoryAdjustment(model: AddInventoryAdjustment): Observable<void> {
    return this.http.post<void>(
      `${this.apiBaseUrl}/inventory/adjustment`,
      model
    );
  }

  getActiveReservationsTTL(versionId: number, filter?: any): Observable<Paged<GetInventoryReservationTTL>> {
    return this.http.get<Paged<GetInventoryReservationTTL>>(`${this.apiBaseUrl}/inventory/reservations/ttl/${versionId}`, {
      params: HttpUtil.toHttpParams(filter ?? {})
    });
  }

  releaseReservation(reservationId: number): Observable<void> {
    return this.http.post<void>(
      `${this.apiBaseUrl}/inventory/reservations/${reservationId}/release`,
      {}
    );
  }
}